import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/sprint/meeting/list", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/sprint/meeting/save", params, successCallback, failCallback, exceptionCallback);
	},merge: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/sprint/meeting/merge", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/sprint/meeting/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/sprint/meeting/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/sprint/meeting/remove", params, successCallback, failCallback, exceptionCallback);
	},selectSummary:(params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/sprint/meeting/selectSummary", params, successCallback, failCallback, exceptionCallback);
	},
	getRemark:(params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/sprint/meeting/getremark", params, successCallback, failCallback, exceptionCallback);
	},
	listBySprint: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(constant.serverUrl + "/sprint/meeting/listBySprint", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
